<template>
  <b-card
    header-tag="header"
    header-bg-variant="primary"
  >
    <template #header>
      <h5 class="mb-0 text-center font-weight-bold text-white text-uppercase">
        {{ $t('control.label.dashboard.title') }}
      </h5>
    </template>
    <b-card-text>
      <b-alert
        v-if="applicant != null"
        class="mb-3"
        show
        variant="dark"
      >
        <a
          href="#"
          class="alert-link"
        >{{ applicant }}
        </a>
      </b-alert>
      <b-card
        class="mb-3"
        border-variant="primary"
        header-bg-variant="primary"
        header-text-variant="white"
        header-class="text-center text-uppercase"
        :header="$t('control.label.dashboard.inProgress.title')"
      >
        <b-card-text>
          <div class="row">
            <div class="mb-1 col-md-8">
              <b-badge
                pill
                :variant="getPilClass('Km')"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">
                {{ $t('control.label.dashboard.inProgress.km') }}
              </span>
            </div>
            <div class="col-md-4 text-right">
              <span>{{ dashboardTotals == null ? 0 : dashboardTotals.inProgressKm }}</span>
            </div>
            <div class="mb-1 col-md-8">
              <b-badge
                pill
                variant="success"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">
                {{ $t('control.label.dashboard.inProgress.uncappedKm') }}
              </span>
            </div>
            <div class="col-md-4 text-right">
              <span>{{ dashboardTotals == null ? 0 : dashboardTotals.inProgressUncappedKm }}</span>
            </div>
            <div
              v-if="expenseType == 'REAL_EXPENSES'"
              class="mb-1 col-md-8"
            >
              <b-badge
                pill
                variant="success"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">
                {{ $t('control.label.dashboard.inProgress.meal') }}
              </span>
            </div>
            <div
              v-if="expenseType == 'REAL_EXPENSES'"
              class="col-md-4 text-right"
            >
              <span>{{ dashboardTotals == null ? 0 : dashboardTotals.inProgressMeal }}</span>
            </div>
            <div
              v-if="expenseType == 'REAL_EXPENSES'"
              class="mb-1 col-md-8"
            >
              <b-badge
                pill
                variant="success"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">
                {{ $t('control.label.dashboard.inProgress.phone') }}
              </span>
            </div>
            <div
              v-if="expenseType == 'REAL_EXPENSES'"
              class="col-md-4 text-right"
            >
              <span>{{ dashboardTotals == null ? 0 : dashboardTotals.inProgressPhone }}</span>
            </div>
            <div
              v-if="expenseType == 'REAL_EXPENSES'"
              class="mb-1 col-md-8"
            >
              <b-badge
                pill
                variant="success"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">
                {{ $t('control.label.dashboard.inProgress.parking') }}
              </span>
            </div>
            <div
              v-if="expenseType == 'REAL_EXPENSES'"
              class="col-md-4 text-right"
            >
              <span>{{ dashboardTotals == null ? 0 : dashboardTotals.inProgressParking }}</span>
            </div>
            <div
              v-if="expenseType == 'FLAT_FEE'"
              class="mb-1 col-md-8"
            >
              <b-badge
                pill
                :variant="getPilClass('BaseAmount')"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">
                {{ $t('control.label.dashboard.inProgress.fee') }}
              </span>
            </div>
            <div
              v-if="expenseType == 'FLAT_FEE'"
              class="col-md-4 text-right"
            >
              <span>{{ dashboardTotals == null ? 0 : dashboardTotals.inProgressBaseAmount }}</span>
            </div>
            <div
              v-if="expenseType == 'FLAT_FEE' && getQuarterlyDisplayInProgress()"
              class="col-md-8"
            >
              <b-badge
                pill
                :variant="getPilClass('ExtendedAmount')"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">{{ $t('control.label.dashboard.inProgress.feeExtended') }}</span>
            </div>
            <div
              v-if="expenseType == 'FLAT_FEE' && getQuarterlyDisplayInProgress()"
              class="col-md-4 text-right"
            >
              <span>{{ dashboardTotals.inProgressQuarterlyAmount }}</span>
            </div>
          </div>
        </b-card-text>
      </b-card>
      <b-card
        class="mb-3"
        border-variant="primary"
        header-bg-variant="primary"
        header-text-variant="white"
        header-class="text-center text-uppercase"
        :header="$t('control.label.dashboard.payed.title')"
      >
        <b-card-text>
          <div class="row">
            <div class="mb-1 col-md-8">
              <b-badge
                pill
                :variant="getPilClass('Km')"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">{{ $t('control.label.dashboard.payed.km') }}</span>
            </div>
            <div class="col-md-4 text-right">
              <span>{{ dashboardTotals == null ? 0 : dashboardTotals.payedKm }}</span>
            </div>
            <div class="mb-1 col-md-8">
              <b-badge
                pill
                variant="success"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">{{ $t('control.label.dashboard.payed.uncappedKm') }}</span>
            </div>
            <div class="col-md-4 text-right">
              <span>{{ dashboardTotals == null ? 0 : dashboardTotals.payedUncappedKm }}</span>
            </div>
            <div
              v-if="expenseType == 'FLAT_FEE'"
              class="mb-1 col-md-8"
            >
              <b-badge
                pill
                :variant="getPilClass('BaseAmount')"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">{{ $t('control.label.dashboard.payed.fee') }}</span>
            </div>
            <div
              v-if="expenseType == 'FLAT_FEE'"
              class="col-md-4 text-right"
            >
              <span>{{ dashboardTotals == null ? 0 : dashboardTotals.payedBaseAmount }}</span>
            </div>
            <div
              v-if="expenseType == 'FLAT_FEE' && getQuarterlyDisplayPayed()"
              class="col-md-8"
            >
              <b-badge
                pill
                :variant="getPilClass('ExtendedAmount')"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">{{ $t('control.label.dashboard.payed.feeExtended') }}</span>
            </div>
            <div
              v-if="expenseType == 'FLAT_FEE' && getQuarterlyDisplayPayed()"
              class="col-md-4 text-right"
            >
              <span>{{ dashboardTotals == null ? 0 : dashboardTotals.payedQuarterlyAmount }}</span>
            </div>
            <div
              v-if="expenseType == 'REAL_EXPENSES'"
              class="mb-1 col-md-8"
            >
              <b-badge
                pill
                variant="success"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">{{ $t('control.label.dashboard.payed.meal') }}</span>
            </div>
            <div
              v-if="expenseType == 'REAL_EXPENSES'"
              class="col-md-4 text-right"
            >
              <span>{{ dashboardTotals == null ? 0 : dashboardTotals.payedMeal }}</span>
            </div>
            <div
              v-if="expenseType == 'REAL_EXPENSES'"
              class="mb-1 col-md-8"
            >
              <b-badge
                pill
                variant="success"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">{{ $t('control.label.dashboard.payed.phone') }}</span>
            </div>
            <div
              v-if="expenseType == 'REAL_EXPENSES'"
              class="col-md-4 text-right"
            >
              <span>{{ dashboardTotals == null ? 0 : dashboardTotals.payedPhone }}</span>
            </div>
            <div
              v-if="expenseType == 'REAL_EXPENSES'"
              class="mb-1 col-md-8"
            >
              <b-badge
                pill
                variant="success"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">{{ $t('control.label.dashboard.payed.parking') }}</span>
            </div>
            <div
              v-if="expenseType == 'REAL_EXPENSES'"
              class="col-md-4 text-right"
            >
              <span>{{ dashboardTotals == null ? 0 : dashboardTotals.payedParking }}</span>
            </div>
          </div>
        </b-card-text>
      </b-card>
      <b-card
        v-if="expenseType == 'FLAT_FEE'"
        class="mb-2"
        border-variant="danger"
        header-bg-variant="danger"
        header-text-variant="white"
        header-class="text-center text-uppercase"
        :header="$t('control.label.dashboard.limit.title')"
      >
        <b-card-text>
          <div class="row">
            <div class="mb-1 col-md-6">
              <b-badge
                pill
                :variant="getPilClass('Km')"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">{{ $t('control.label.dashboard.limit.km') }}</span>
            </div>
            <div class="col-md-6 text-right">
              <span>
                {{ dashboardTotals == null ? 0 : dashboardTotals.totalKm }}
                &nbsp;/&nbsp;
                <b>{{ dashboardTotals == null ? 0 : dashboardTotals.ceillingKm }}</b>
              </span>
            </div>
            <div class="mb-1 col-md-6">
              <b-badge
                pill
                :variant="getPilClass('BaseAmount')"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">{{ $t('control.label.dashboard.limit.fee') }}</span>
            </div>
            <div class="col-md-6 text-right">
              <span>
                {{ dashboardTotals == null ? 0 : dashboardTotals.totalBaseAmount }}
                &nbsp;/&nbsp;
                <b>{{ dashboardTotals == null ? 0 : dashboardTotals.ceillingBaseAmount.toFixed(2) }}</b>
              </span>
            </div>
            <div
              v-if="expenseType == 'FLAT_FEE' && (dashboardTotals == null ? false : dashboardTotals.ceillingQuarterlyAmount > 0)"
              class="mb-1 col-md-6"
            >
              <b-badge
                pill
                :variant="getPilClass('ExtendedAmount')"
              >
                &nbsp;
              </b-badge>
              <span class="pl-2 font-weight-bold">{{ $t('control.label.dashboard.limit.feeExtended') }}</span>
            </div>
            <div
              v-if="expenseType == 'FLAT_FEE' && dashboardTotals == null ? false : dashboardTotals.ceillingQuarterlyAmount > 0"
              class="col-md-6 text-right"
            >
              <span>
                {{ dashboardTotals == null ? 0 : dashboardTotals.totalQuarterlyAmount }}
                &nbsp;/&nbsp;
                <b>{{ dashboardTotals == null ? 0 : dashboardTotals.ceillingQuarterlyAmount.toFixed(2) }}</b>
              </span>
            </div>
          </div>
        </b-card-text>
      </b-card>
    </b-card-text>
  </b-card>
</template>

<script>
import people from '../services/People';

export default {
  data() {
    return {
      dashboardTotals: null,
      applicant: null,
      expenseType: this.$store.getters['authorization/data'].expenseTypeNavigation != null ? this.$store.getters['authorization/data'].expenseTypeNavigation.key : null,
    };
  },
  mounted() {
    this.getDashboard();
    this.$root.$on('forceUpdateDashboard', (personId, applicant) => {
      setTimeout(() => {
        this.getDashboard(personId, applicant);
        this.getPerson(personId);
      }, 1500);
    });
  },
  methods: {
    async getDashboard(personId, applicant) {
      if (this.$store.getters['authorization/data'].needVerification) return;
      this.applicant = applicant;
      let value = null;
      if (personId == null) value = await people.getDashboard(this.$store.getters['authorization/data'].id);
      else value = await people.getDashboard(personId);
      // eslint-disable-next-line prefer-destructuring
      this.dashboardTotals = value[1];
    },
    async getPerson(personId) {
      let result = null;
      people.baseUrl = this.$store.state.settings.apiBaseUrl;
      if (personId == null) result = await people.get(this.$store.getters['authorization/data'].id);
      else result = await people.get(personId);
      this.$nextTick(async () => {
        if (result[1] != null) {
          this.expenseType = result[1].expenseTypeNavigation.key;
        }
      });
    },
    getQuarterlyDisplayInProgress() {
      if (this.dashboardTotals == null) return false;
      if (this.dashboardTotals.inProgressQuarterlyAmount == null) return false;
      return this.dashboardTotals.inProgressQuarterlyAmount > 0;
    },
    getQuarterlyDisplayPayed() {
      if (this.dashboardTotals == null) return false;
      if (this.dashboardTotals.payedQuarterlyAmount == null) return false;
      return this.dashboardTotals.payedQuarterlyAmount > 0;
    },
    getPilClass(pil) {
      if (this.dashboardTotals == null) return 'success';
      if (String(pil) === 'Km') {
        if (Number(this.dashboardTotals.ceillingKm) === Number(this.dashboardTotals.totalKm)) {
          return 'danger';
        }
        if (Number(this.dashboardTotals.totalKm) >= Number(this.dashboardTotals.ceillingKm) / 1.75) {
          return 'warning';
        }
        return 'success';
      }
      if (String(pil) === 'BaseAmount') {
        if (Number(this.dashboardTotals.ceillingBaseAmount) === Number(this.dashboardTotals.totalBaseAmount)) {
          return 'danger';
        }
        if (Number(this.dashboardTotals.totalBaseAmount) >= Number(this.dashboardTotals.ceillingBaseAmount) / 1.75) {
          return 'warning';
        }
        return 'success';
      }
      if (String(pil) === 'ExtendedAmount') {
        if (Number(this.dashboardTotals.ceillingQuarterlyAmount) === Number(this.dashboardTotals.totalQuarterlyAmount)) {
          return 'danger';
        }
        if (Number(this.dashboardTotals.totalQuarterlyAmount) >= Number(this.dashboardTotals.ceillingQuarterlyAmount) / 1.75) {
          return 'warning';
        }
        return 'success';
      }
      return 'success';
    },
  },
};
</script>
